import "../css"

addEventListener("turbo:load", function() {
  $("table.admins").sortable({
    items: "tr[data-id]",
    axis: "y",
    stop: function(e, ui) {
      var item = ui.item
      $.ajax({
        url: `/admin/admins/${item.attr("data-id")}`,
        method: "PATCH",
        data: { "admin[rank]": item.index("tr[data-id]") },
        dataType: "script"
      })
    }
  })
})
